import { useEffect, useState } from 'react';
import { Box, Button, Paper, Avatar, CardHeader } from '@material-ui/core';
import moment from 'moment';
import { useStyles } from './style';
import { APPOINTMENT_DETAILS, APPOINTMENTS } from '../../utils/urls';
import { useHistory } from 'react-router-dom';
import DoctariModal from '../../components/Modal';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

function AppointmentCard({
  theme,
  appointment,
  isProfessional,
  session,
  getNewAccessToken,
  userState,
  deleteAppointment,
  appointmentData,
  getMpPreference,
}) {
  const location = useLocation();
  const styles = useStyles();
  const history = useHistory();
  const [actualDate, setActualDate] = useState(moment());
  const [modalOpen, setModalOpen] = useState(false);

  const handlePayment = () => {
    let date = moment(appointment.date).format('MM-DD-YYYY');
    const body = {
      title: `Consulta Basa ${date}`,
      price: userState.patientPlan.appointment_price,
      appointment: appointment.id,
    };
    getMpPreference(body);
  };

  useEffect(() => {
    // When appointment is deleted
    appointmentData.success.genericMessage ==
      'Appointment eliminado con exito' && history.push(APPOINTMENTS);
  }, [appointmentData.success]);
  useEffect(() => {
    if (userState?.mpPreference?.auto_return == 'approved') {
      window.location.replace(userState.mpPreference.init_point);
    }
  }, [userState?.mpPreference]);

  const handleSeeAppointment = () => {
    history.push({
      pathname: APPOINTMENT_DETAILS,
      state: {
        appointment,
      },
    });
  };

  const handleDeleteAppointment = () => {
    deleteAppointment(appointment.id);
  };

  useEffect(() => {
    let secTimer = setInterval(() => {
      setActualDate(moment());
    }, 5000); //every five seconds we get the actual Date time to update "IR"

    return () => clearInterval(secTimer);
  }, []);

  useEffect(() => {
    if (userState.success == 'Nuevo token obtenido con éxito') {
      let pageName =
        process.env.REACT_APP_VIDEO_URL +
        'appointment/' +
        appointment.id +
        '/?idUser=' +
        session.id +
        '&token=' +
        session.accessToken;
      window.open(pageName);
    }
  }, [userState.success]);

  return (
    <>
      <DoctariModal
        open={modalOpen}
        setOpen={setModalOpen}
        title={'Consulta caducada'}
        hideCross
      >
        <p style={{ margin: '5%' }}>
          <strong>Política de pago:</strong>
          El pago debe ser realizado 6 horas antes de la consulta. Para más
          información puede contactarse con un asistente.
        </p>
        <Button
          style={{ float: 'right', margin: '10px' }}
          variant="contained"
          color="primary"
          onClick={handleDeleteAppointment}
        >
          Aceptar
        </Button>
      </DoctariModal>
      <Paper
        style={{
          borderTop: `2px solid ${theme.palette.primary.main}`,
          width: 300,
          padding: '1.5rem',
          margin: '0.5rem',
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          flexWrap="wrap"
          flexDirection="column"
        >
          <span>
            {'Consulta: '}
            <span style={{ fontWeight: 'bold' }}>{` ${moment(appointment.date)
              .tz(moment.tz.guess())
              .format('DD-MM-YYYY HH:mm [hs]')}`}</span>
          </span>
        </Box>
        <Box>
          <CardHeader
            style={{ paddingLeft: '0px' }}
            avatar={
              <Avatar
                alt="Foto de perfil"
                src={
                  appointment.patient //TODO todos los chequeos de appointment.patient hay que sacarlos, quedaron appointment con patient= null por error, hay que limpiarlos
                    ? isProfessional
                      ? appointment.patient.profile_picture &&
                        appointment.patient.profile_picture.url
                      : appointment.doctor.profile_picture &&
                        appointment.doctor.profile_picture.url
                    : null
                }
                style={{
                  height: '60px',
                  width: '60px',
                }}
                className={styles.avatar}
              />
            }
            title={`${
              appointment.patient
                ? `${
                    isProfessional
                      ? appointment.patient.full_name
                      : appointment.doctor.full_name
                  }`
                : 'Patient'
            }`}
            subheader={
              isProfessional ? (
                <div>
                  <span style={{ fontWeight: 'bold' }}>
                    {appointment.patient
                      ? `CI: ${appointment.patient.identity_document}`
                      : 'Patient null'}
                  </span>
                  <br></br>{' '}
                  <span>
                    {appointment.patient
                      ? `Nacimiento: ${appointment.patient.date_of_birth}`
                      : 'Patient null'}
                  </span>
                </div>
              ) : (
                <div>{appointment.doctor.specialty.name}</div>
              )
            }
          />
        </Box>
        <Box marginTop="1rem">
          <span style={{ fontWeight: 300 }}>Motivo de la consulta: </span>
        </Box>
        <Box>
          <span style={{ fontWeight: 'bold' }}>
            {appointment.patient
              ? appointment.patient_appointment_reason
              : 'Null'}
          </span>
        </Box>

        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexWrap="wrap"
          style={{ margin: '10px' }}
        >
          <Button
            color="primary"
            variant="contained"
            style={{ marginRight: '2rem' }}
            //disabled={moment(appointment.date).diff(actualDate, 'minutes') > 5}
            onClick={handleSeeAppointment}
          >
            Ver
          </Button>

          {appointment.is_payed && (
            <Button
              color="primary"
              variant="contained"
              //disabled={moment(appointment.date).diff(actualDate, 'minutes') > 5}
              onClick={() => {
                let pageName;
                if (appointment.is_light) {
                  pageName =
                    process.env.REACT_APP_VIDEO_URL +
                    'appointment/' +
                    appointment.id +
                    '/?idUser=' +
                    session.id +
                    '&token=' +
                    session.accessToken +
                    '&light=1';
                } else {
                  pageName =
                    process.env.REACT_APP_VIDEO_URL +
                    'appointment/' +
                    appointment.id +
                    '/?idUser=' +
                    session.id +
                    '&token=' +
                    session.accessToken;
                }
                window.location.href = pageName;
              }}
            >
              IR
            </Button>
          )}
          {!appointment.is_payed && (
            <Button
              variant="contained"
              style={{
                backgroundColor: '#4BB543',
                color: 'white',
              }}
              onClick={handlePayment}
            >
              Pagar
            </Button>
          )}
        </Box>
      </Paper>
    </>
  );
}

export default AppointmentCard;
